const component = require('../component/component');

const ticketsList = Object.assign({}, component, {
    subelements: {},
    ticketElements: {},
    init: function () {
        component.init.call(this);
        let ticketElements = this.element.querySelectorAll('[data-zit-tickets-list-item-for="' + this.id + '"]');

        // Resolve the theme-mapped displayNone class once per init; reused across both event handlers.
        let displayNoneClass = this.hm.app.cssClass('displayNone');

        ticketElements.forEach((ticketElement) => {
            let ticketId = ticketElement.dataset.zitTicketsListItemId;
            this.ticketElements[ticketId] = ticketElement;
            ticketElement.addEventListener('show.bs.collapse', () => {
                // Toggle the theme-mapped displayNone class on the short-description and owner subelements.
                ticketElement.querySelector('[data-zit-subelement-type="shortDescription"]').classList.toggle(displayNoneClass);
                ticketElement.querySelector('[data-zit-subelement-type="owner"]').classList.toggle(displayNoneClass);
            });

            ticketElement.addEventListener('hide.bs.collapse', () => {
                // Toggle back when the row collapses.
                ticketElement.querySelector('[data-zit-subelement-type="shortDescription"]').classList.toggle(displayNoneClass);
                ticketElement.querySelector('[data-zit-subelement-type="owner"]').classList.toggle(displayNoneClass);
            });
        });
    }
});

module.exports = ticketsList;